import styled from 'styled-components'
import { flexbox, FlexboxProps, padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) => !['flexDirection'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps & FlexboxProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX};
  background-color: ${themeGet('colors.background.screenAccent')};
  gap: ${themeGet('space.8')}px;

  ${padding}
  ${flexbox}
`

export const ImageHolder = styled.figure`
  display: flex;
  width: 100%;
  max-width: 520px;

  > img {
    width: 100%;
    height: auto;
  }
`
